import React, { useEffect, useContext } from 'react';
import { createPortal } from 'react-dom';
import { PortalContext } from '@nile/components';
import nanoid from 'nanoid';

function noop() {}

export default function Portal({
  children,
  idPrefix = '',
  className,
  onPortalCreated = noop
}) {
  return createPortal(
    <div data-portal-id={`${idPrefix} ${nanoid()}`} className={className}>
      {children}
    </div>,
    document.body
  );
}
